import useMergedData from '../../hooks/useMergedData'
import DiagramFrame from './DiagramFrame'
import DiagramNode from './DiagramNode'
import DiagramLink from './DiagramLink'
import Typography from '@mui/material/Typography'
import ModalLLM from '../ModalLLM'
import NextPrev from './NextPrev'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

export default function OnboardLLM() {
  const { nodes, networks } = useMergedData()
  const network: NetworkRecord | undefined = networks[0]
  const node: NodeRecord | undefined = nodes[0]

  return (
    <>
      <Grid size={{ xs: 12, sm: 3.5 }} />
      <Grid size={{ xs: 12, sm: 8.5 }}>
        <Typography variant="h1">Connect your LLM</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 3.5 }} sx={{
        paddingTop: 4
      }}>
        <Typography variant="h5">
          You can now log into your{' '}
          <Box component="span" sx={{
            color: 'primary.main'
          }}>
            Language Model
          </Box>{' '}
          to control your compute node.
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 8.5 }}>
        <DiagramFrame
          left={<DiagramNode label="Language Model" type="llm" />}
          middle={
            <>
              <Box
                sx={{
                  position: 'absolute',
                  width: '240%'
                }}>
                <DiagramLink offline />
              </Box>
              <DiagramNode type="network" label={network?.name} currentColor />
            </>
          }
          right={<DiagramNode label={node?.name ?? 'Compute Node'} type="node" />}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3.5 }}>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            marginBottom: 2
          }}>
          You should be able to do most everything you need to do with your language model now.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontStyle: 'italic',
            marginBottom: 3
          }}>
          Return here to manage your account and networks.
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 8.5 }}>
        <ModalLLM inline />
      </Grid>
      <Grid
        size={12}
        sx={{
          marginTop: 4,
          textAlign: 'right'
        }}>
        <NextPrev label="Done" prev="/onboard/node" />
      </Grid>
    </>
  )
}
